import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import styled from 'styled-components';
import { color, themeGet } from '@magalu/stereo-ui-styles';
export var Container = styled.div.attrs(function () {
  return {
    bg: 'background.primary'
  };
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  width: 100%;\n\n  #seloEbit > img {\n    height: 40px;\n    width: auto;\n    margin-right: ", "px;\n  }\n\n  ", "\n"])), themeGet('space.3'), color);